import { render, staticRenderFns } from "./EnterForgotPin.vue?vue&type=template&id=8b8831d8&"
import script from "./EnterForgotPin.vue?vue&type=script&lang=js&"
export * from "./EnterForgotPin.vue?vue&type=script&lang=js&"
import style0 from "./EnterForgotPin.vue?vue&type=style&index=0&id=8b8831d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports